import React from 'react';

import Button from '@amzn/meridian/button';
import Row, { type RowProps } from '@amzn/meridian/row/row';
import DebounceSearchField from 'src/components/shared/debounceSearchField/debounceSearchField';
import {
  setIsTaskModalOpen,
  setTaskSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Default component
 */
const TopOptions = (props: RowProps) => {
  const dispatch = useAppDispatch();
  const { taskSearchFieldValue } = useAppSelector((state) => state.taskConfigPage);

  return (
    <Row alignmentHorizontal="justify" {...props}>
      <Row>
        <DebounceSearchField
          value={taskSearchFieldValue}
          onDebounce={(v) => dispatch(setTaskSearchFieldValue(v))}
          placeholder="Search for..."
        />
      </Row>
      <Row>
        <Button
          minWidth={98}
          className="view-and-edit-tasks__open-modal"
          onClick={() => dispatch(setIsTaskModalOpen(true))}
        >
          Add Task
        </Button>
      </Row>
    </Row>
  );
};

// **** Export **** //

export default TopOptions;
